import React from 'react'
import _get from 'lodash/get'
import { setLocale as setYupLocale } from 'yup'

let currentLanguageCode = ''

const languages: {
  [key: string]: {
    id: string
    label: string
    flag: string
    dateFns: any
    dictionary: any
  }
} = {
  en: {
    id: 'en',
    label: 'English',
    flag: '/images/flags/United-States.png',
    dateFns: null,
    dictionary: null,
  },
}

export async function init() {
  currentLanguageCode = localStorage.getItem('language') || 'en'
  setLanguageCode(currentLanguageCode)

  if (currentLanguageCode === 'en') {
    await initEn()
  }
}

async function initEn() {
  const language = languages['en']

  language.dictionary = (await import('src/i18n/en')).default

  if (language.dictionary.validation) {
    setYupLocale(language.dictionary.validation)
  }

  return language
}

export function getLanguage() {
  const code = getLanguageCode()
  const lang = languages[code]
  return lang
}

function format(message: any, args: any) {
  if (!message) {
    return null
  }

  try {
    return message.replace(/{(\d+)}/g, function (match: any, number: any) {
      return typeof args[number] != 'undefined' ? args[number] : match
    })
  } catch (error) {
    console.error(message, error)
    throw error
  }
}

export function getLanguages() {
  return Object.keys(languages).map((language) => {
    return languages[language]
  })
}

export function getLanguageCode() {
  return currentLanguageCode
}

export function setLanguageCode(arg: string) {
  if (!languages[arg]) {
    throw new Error(`Invalid language ${arg}.`)
  }

  localStorage.setItem('language', arg)
}

export function i18nExists(key: string) {
  if (!getLanguage()) {
    return false
  }

  const message = _get(getLanguage().dictionary, key)
  return Boolean(message)
}

export function i18n(key: string, ...args: Array<any>) {
  if (!getLanguage()) {
    return key
  }

  const message = _get(getLanguage().dictionary, key)

  if (!message) {
    return key
  }

  return format(message, args)
}

export function i18nHtml(key: string, ...args: Array<any>) {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: i18n(key, ...args),
      }}
    />
  )
}
